import type { IconSvgObject } from './types';

const CircleChevronUpIcon: IconSvgObject = [
  ["path", { d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 13.5L10.5858 10.9761C11.2525 10.3254 11.5858 10 12 10C12.4142 10 12.7475 10.3254 13.4142 10.9761L16 13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CircleChevronUpIcon;
